import React, { useState } from "react";
import { Form, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../utils/API"; 

const Register: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    setIsLoading(true);
    try {
      await registerUser(values);
      message.success("Registration successful! Please log in.");
      setIsLoading(false);
      navigate("/login"); // Redirect to login
    } catch (error: any) {
      setIsLoading(false);
      message.error(error.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl border border-blue-500 rounded-lg">
        <div className="mt-3 sm:mx-auto sm:w-full sm:max-w-xl">
          <Form initialValues={{ remember: true }} onFinish={onFinish} className="m-4">
            <label className="font-bold m-2">Name</label>
            <Form.Item name="username" rules={[{ required: true, message: "Please enter your name!" }]}>
              <Input placeholder="Enter your name" className="antInputClass rounded" />
            </Form.Item>

            <label className="font-bold m-2">Email</label>
            <Form.Item name="email" rules={[{ required: true, message: "Please enter your email!" }]}>
              <Input placeholder="Enter email" className="antInputClass rounded" />
            </Form.Item>

            <label className="font-bold m-2">Phone Number</label>
            <Form.Item name="mobileNo" rules={[{ required: true, message: "Please enter your phone number!" }]}>
              <Input placeholder="Enter phone number" className="antInputClass rounded" />
            </Form.Item>

            <label className="font-bold m-2">Password</label>
            <Form.Item name="password" rules={[{ required: true, message: "Please enter your password!" }]}>
              <Input.Password placeholder="Enter password" className="antInputClass rounded p-2" />
            </Form.Item>

            <Form.Item>
              <button type="submit" disabled={isLoading} className="w-full p-3 rounded-md bg-[#001529] text-white">
                {isLoading ? "Signing up..." : "Sign Up"}
              </button>
            </Form.Item>

            <div className="text-center">
              <span className="text-gray-600">Already have an account? </span>
              <Link to="/login" className="text-blue-500 hover:underline">Sign in here</Link>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Register;
